import Skeleton from 'react-loading-skeleton';
import { Price } from '../__simple/_price';
import { toast } from 'react-toastify';

export default function MobileStickyFooter({
    isLoading,
    selectedColor,
    trans,
    finance,
    financeSettings,
    lang,
    vehicle,
    history,
    scrollSnackUp,
    setScrollSnackUp,
    setShowFinalPopupMessage,
}) {
    const isExpanded = scrollSnackUp.show;

    const toggleExpand = (event) => {
        if (!event?.target?.id.includes('footer-actions-buy')) {
            const currentValue = { ...scrollSnackUp };
            currentValue.show = !currentValue.show;
            currentValue.height = currentValue.show ? 'auto' : '88px';
            setScrollSnackUp(currentValue);
        }
    };

    return (
        <div
            id="parent-footer"
            style={{
                position: 'fixed',
                bottom: 0,
                left: 0,
                right: 0,
                zIndex: 1000,
                padding: isExpanded ? '20px 20px 40px' : '20px 24px',
                borderRadius: '24px 24px 0 0',
                background: 'var(--surface)',
                boxShadow: '0 -10px 40px rgba(0,0,0,0.08)',
                borderTop: '1px solid rgba(0,0,0,0.05)',
                transition: 'all .4s var(--ease)',
                maxHeight: isExpanded ? '85vh' : '120px',
                overflow: 'hidden'
            }}
            onClick={toggleExpand}
        >
            {/* Top Pull Bar for expanded state */}
            {isExpanded && (
                <div style={{
                    width: '40px',
                    height: '4px',
                    borderRadius: '2px',
                    background: 'rgba(0,0,0,0.1)',
                    margin: '0 auto 20px'
                }}></div>
            )}

            {isLoading ? (
                <Skeleton count={1} borderRadius="1rem" width="100%" height="5rem" />
            ) : selectedColor?.buyOnline ? (
                <>
                    {/* Collapsed top row */}
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '15px' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                            {/* Cash Price Row */}
                            <div style={{ display: 'flex', alignItems: 'baseline', gap: '4px' }}>
                                <span style={{ fontSize: '11px', fontWeight: 700, color: 'var(--t2)' }}>{trans('new:cash')}:</span>
                                <span style={{ fontSize: '20px', fontWeight: 900, color: 'var(--dark)' }}>
                                    {selectedColor?.NetSalePrice && <Price price={parseFloat(selectedColor?.NetSalePrice)} hideCurrency={true} />}
                                </span>
                            </div>

                            {/* Monthly Installment Row */}
                            {!isExpanded && finance?.price && (
                                <div style={{ display: 'flex', alignItems: 'baseline', gap: '4px' }}>
                                    <span style={{ fontSize: '11px', fontWeight: 700, color: 'var(--t2)' }}>{trans('new:monthly')}:</span>
                                    <span style={{ fontSize: '16px', fontWeight: 800, color: 'var(--g)' }}>
                                        <Price price={parseFloat(finance?.price.toFixed(2))} hideCurrency={true} />
                                    </span>
                                </div>
                            )}
                        </div>

                        {/* Book Now Button */}
                        <div
                            id="footer-actions-buy"
                            style={{
                                flex: 1,
                                maxWidth: '150px',
                                height: '50px',
                                borderRadius: '100px',
                                background: 'var(--g)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                cursor: 'pointer',
                                fontWeight: 600,
                                fontSize: '15px',
                                color: '#fff',
                                boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
                                transition: 'all .3s var(--ease)'
                            }}
                            onClick={(e) => {
                                e.stopPropagation();
                                try {
                                    if (vehicle) {
                                        history.push({
                                            pathname: `/car/checkout/${selectedColor?.SN}/${selectedColor?.ProductTarget}`,
                                            search: '',
                                        });
                                    }
                                } catch (error) { }
                            }}
                        >
                            {trans('new:book_now')}
                        </div>
                    </div>

                    {/* Expanded financing detail */}
                    {isExpanded && (
                        <div style={{ marginTop: '30px', display: 'flex', flexDirection: 'column', gap: '20px', overflowY: 'auto' }}>
                            {finance?.totalPrice ? (
                                <>
                                    <div style={{ textAlign: 'center' }}>
                                        <div style={{ fontSize: '12px', fontWeight: 600, color: 'var(--t2)', marginBottom: '4px' }}>{trans('new:installment_price')}</div>
                                        <div style={{ fontSize: '32px', fontWeight: 900, color: 'var(--g)', letterSpacing: '-0.5px' }}>
                                            <Price price={finance?.price} />
                                        </div>
                                    </div>

                                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                                        {[
                                            { label: trans('finance:period'), value: `${finance?.period} ${trans('info:month')}` },
                                            { label: trans('new:first_batch'), value: <Price price={finance?.first} hideCurrency={true} /> },
                                            { label: trans('new:last_batch'), value: <Price price={finance?.last} hideCurrency={true} /> },
                                            { label: trans('finance:management_fees'), value: <Price price={finance?.mangFees} hideCurrency={true} /> },
                                        ].map((row, idx) => (
                                            <div key={idx} style={{ padding: '14px', borderRadius: '16px', background: 'var(--bg2)', display: 'flex', flexDirection: 'column', gap: '4px' }}>
                                                <span style={{ fontSize: '11px', fontWeight: 600, color: 'var(--t2)' }}>{row.label}</span>
                                                <span style={{ fontSize: '15px', fontWeight: 800, color: 'var(--dark)' }}>{row.value}</span>
                                            </div>
                                        ))}
                                    </div>

                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '14px', borderRadius: '16px', background: 'var(--bg)', border: '1px solid rgba(24,169,78,0.15)', color: 'var(--g)' }}>
                                        <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2.5">
                                            <circle cx="12" cy="12" r="10" />
                                            <line x1="12" y1="16" x2="12" y2="12" />
                                            <line x1="12" y1="8" x2="12.01" y2="8" />
                                        </svg>
                                        <p style={{ fontSize: '12px', fontWeight: 700, margin: 0 }}>
                                            {trans('finance:This_calculation_is_estimate')}
                                        </p>
                                    </div>

                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            gap: '6px',
                                            color: 'var(--g)',
                                            fontSize: '15px',
                                            fontWeight: 800,
                                            marginTop: '10px'
                                        }}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setShowFinalPopupMessage(true);
                                        }}
                                    >
                                        <span style={{ borderBottom: '1.5px solid currentColor', paddingBottom: '2px' }}>{trans('new:financing_details')}</span>
                                        <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="3">
                                            <polyline points="9 18 15 12 9 6" />
                                        </svg>
                                    </div>
                                </>
                            ) : null}
                        </div>
                    )}
                </>
            ) : (
                /* Not available state */
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '15px' }}>
                    <div style={{ fontSize: '16px', fontWeight: 800, color: '#ef4444' }}>{trans('new:not_available')}</div>
                    <div
                        style={{
                            flex: 1,
                            maxWidth: '200px',
                            height: '50px',
                            borderRadius: '100px',
                            background: 'var(--bg2)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '8px',
                            cursor: 'pointer',
                            fontSize: '14px',
                            fontWeight: 700,
                            color: 'var(--t2)',
                            transition: 'all .3s var(--ease)'
                        }}
                        onClick={(e) => {
                            e.stopPropagation();
                            toast.warning(trans('new:Notification_will_be_sent_when_available'));
                        }}
                    >
                        <span>{trans('new:alert_when_available')}</span>
                        <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.5">
                            <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
                            <path d="M13.73 21a2 2 0 0 1-3.46 0" />
                        </svg>
                    </div>
                </div>
            )}
        </div>
    );
}
